module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/toc#prl",
      "id": "prl"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("KATE HENDERSON GAZED")]), _vm._v(" through the windscreen at the steady drizzle and tried to hold back her increasingly familiar sense of dread. ‘Stop it, Rav.’ Her deputy was rhythmically tapping the steering-wheel, as he always did when he was bored or nervous or both.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re in a shit mood today,’ he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Thanks. That’ll definitely help.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The radio burst into life at the same time as the street in front of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She’s bolted,’ a voice announced over the static, as Lena Savic raced past them, a vivid dash of colour in the drab London day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Fuck,’ Rav muttered. He and Kate each grabbed a door handle and sprang out of the car.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lena wove her way through the Kingston lunchtime shoppers with the deftness of an international rugby fly half, her long blonde ponytail swinging. Kate followed her "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("along the pavement while Rav ran down the middle of the road, shouting at her to stop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lena darted left into a yard at the rear of a dry cleaner’s. She scrambled onto the lid of a refuse bin, bounced up to the top of the wall behind it and crashed down onto the neighbouring corrugated-iron roof.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kate followed her. She almost slipped off the coping that topped the wall, but regained her balance and jumped clear of the roof onto the tarmac. She rolled once, straightened, and followed as Rav blocked the only exit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lena realized she was trapped, spun around to face them, like a cornered wildcat, then ducked into the gloom of a bicycle workshop. She charged up an iron staircase but the windows there were barred. She had propelled herself deeper into the trap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She came back down the stairs with a bike chain in her hand as a tall, close-cropped mechanic in an oil-stained boiler-suit emerged from a side office. ‘What the fuck—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Stay where you are!’ Rav yelled at him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Up close now, Kate could see the girl’s piercing blue eyes and high cheekbones. Her mouth was twisted in a defiant snarl that revealed a set of gleaming white teeth, at least two of which were broken or chipped. A childish, crudely drawn cross was tattooed on one forearm. The expression of the cartoon "), _c('i', [_vm._v("femme fatale")]), _vm._v(" that rippled across the other bore more than a passing resemblance to her own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Put it down, Lena,’ Kate said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Who are you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You need to come with us.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Who are you? How do you know my name?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Put down the chain.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('i', [_vm._v("‘Put it down!’")]), _vm._v(" The echoing command came from a uniformed police constable, who had appeared at her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lena lunged, swinging the chain so fiercely that Kate felt the rush of air on her cheek as she side-stepped to avoid it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Put it down, Lena,’ Kate said again. ‘Or this is going to get much, much worse for you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ve done nothing wrong.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The constable nodded at his companion and closed in on her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kate stepped back and watched Lena struggle, a wiry five foot five, full of rage, spitting and biting as she tried to fight them off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was exactly what they needed.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("An hour later, Kate leant against the glass of the one-way mirror in the local police station as she watched the two female detectives at work. They emerged after a few moments, closing the door carefully behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She’s all yours, ma’am,’ the older of the two said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kate nodded. ‘Thank you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At seventeen, Lena was barely two years older than Kate’s own daughter and the contrast was haunting. The terrible circumstances of her birth and upbringing shone through the anger in those blue eyes. She was staring straight ahead through the glass. She knew she was being watched, and dared her tormentors to do their worst.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kate left her shoulder bag where it lay and slipped into the room. She placed a slim folder on the table between them and sat down. ‘Good afternoon. My name is Sarah Johnston.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lena stared at her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("‘You still claim you don’t know how the bracelets got into your bag?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How did you know my name?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ll come to that in a moment. How did the bracelets get into your bag?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("‘He")]), _vm._v(" put them there.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Who is "), _c('i', [_vm._v("he")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I told them!’ She gestured at the policewomen’s point of departure. ‘The store detective. He came over and asked if I would go out for a drink with him. I said no. Then he arrested me, took me to the stock room and said he would only let me go if I gave him a blow-job.’ Her English was good, her accent only faint. She was a bright girl, who had evidently learnt fast. ‘So who are you? How did you know my name?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kate picked up the remote control, gestured at the screen on the wall and pressed play. They both watched the footage, which clearly showed the security officer inspecting her bag and lifting out three gold bracelets. ‘And yet there they are.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He planted them!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So you say.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He was harassing me. He must have slipped them into—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I know he did,’ Kate said. ‘I told him to.’ She opened the folder. ‘You’re here illegally, Lena. You do understand that we’ll have to send you home?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lena shook her head slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kate pushed a freeze frame from a CCTV camera across the table. ‘Recognize this?’ It showed Lena, in a short skirt and knee-high leather boots, on a street with a man in a leather jacket. ‘Milos Bravic, one of Europe’s most notorious sex traffickers. A monster, as I hardly need tell you. I can "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("only imagine the courage and guile required to escape his clutches and recreate yourself as the clean-cut au pair from Clapham.’ Kate handed Lena a shot of her walking into Clapham Junction station in blue jeans and a crisp white shirt, her tattoos carefully hidden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Who "), _c('i', [_vm._v("are")]), _vm._v(" you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kate spread three Belgrade police photographs in front of her, and glanced through the accompanying statements as if she was acquainting herself with them for the first time. ‘You insisted that those bruises to your face, neck, upper body and breasts were the result of falling off the bunk bed you shared with your sister.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lena closed her eyes. And Kate caught a glimpse of the wounded child within.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We know your stepfather beat you, Lena. But what else did he do to you?’ Kate turned the page. ‘Here’s the X-ray of your sister’s skull from the hospital on Kralja Milutina last weekend. This time, he managed to keep his handiwork away from police scrutiny.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lena didn’t lift her gaze from the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Look at it, Lena. Your sister is home alone, except for your mother and your stepfather. And you know what that means.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slowly Lena shook her head. ‘You are not a policewoman.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, I’m not.’ Kate glanced at the photograph. ‘My daughter is the same age as Maja. She even looks a little like her.’ It was a line Kate might have used anyway, but it also happened to be disconcertingly true. ‘I know what I would be feeling if he’d done that to her.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lena looked up at her. ‘Who are you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m with the British Secret Intelligence Service.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What do you want?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("‘You.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You sold yourself to the sex traffickers to get here, then managed to escape their clutches. You’re clearly a remarkable young woman and I need your help.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How could "), _c('i', [_vm._v("I")]), _vm._v(" possibly help "), _c('i', [_vm._v("you")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We have a job for you. It’s simple, straightforward and not unpleasant. If you were prepared to do it, I’d help you in return.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We would allow you to stay in this country. We could arrange for your sister to come and join you. We’d pay you enough to tide you both over for a while and enable you to get somewhere to live.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How much?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Enough.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And we could both stay here?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kate saw something like hope spark in her eyes, despite the air of brittle cynicism that was her first line of defence against the only world she’d ever known. She nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘For ever?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you wanted to.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We would have … passports?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’s a complicated process, but in time … We always look after our own.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why me?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The job requires a young au pair or nanny who speaks Russian. It needs someone with courage, which you clearly have in abundance.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Many people speak Russian.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We need someone who is not Russian but comes from a country that Moscow would view as being within its sphere "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("of influence. It’s a job that requires tenacity, toughness and intelligence. You would be perfect.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lena stared at her. ‘What would I have to do?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The same kind of work you’ve been doing in London for the last few weeks.’ Kate reached for the folder and extracted a final photograph. ‘This is the "), _c('i', [_vm._v("Empress.")]), _vm._v(" She’ll be cruising the Mediterranean this autumn. The owner’s son and his wife need an au pair for their three-year-old son.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lena gazed at the massive, gleaming super-yacht. ‘And what would I have to do for "), _c('i', [_vm._v("you")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Once in a while, we’d want to talk about what you might have seen, who came, who went. That’s all.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’d be a spy?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Just eyes and ears.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Who is the owner?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He used to be the head of Russia’s Secret Service.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So I would be listening to him?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes. And some of his friends.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A suicide mission.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No,’ Kate said. ‘You’d be employed by a reputable Western agency. The worst that could happen is that you’d be summarily dismissed and thrown off at the next port.’ She waited.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘They’d kill me—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’d be fired. There would be angry words, but no more. The owner belongs to that small group of oligarchs who are still able to store most of their money in the West and haven’t been impacted by sanctions. We have, of course, deliberately chosen to keep it that way. He couldn’t afford the scandal that would erupt if anything happened to you somewhere other than his own backyard.’ She treated Lena to a warm, motherly smile. ‘A few weeks in the sun and your life will be truly your own.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("‘The Russians do what they want, wherever they want. There. Here. They don’t care. Everyone knows that. Milos and all those other bastards in Belgrade – they all answer to the big bosses back in Moscow. Serbia is just a playground for them. So they do what they like.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not the ones who keep their money where we can find it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a very long silence. Eventually Lena said, ‘I can’t do it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m very sorry to hear that,’ Kate said, ‘but not as sorry, I think, as your sister will be.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A single tear rolled down Lena’s cheek. She brushed it away, clearly furious with herself for betraying weakness. ‘The Russians kill whoever they want to kill. All over the world. Here in England, at home in Belgrade. Everybody knows that.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kate leant forward again and laid a hand on Lena’s forearm. ‘Maja really does look like my daughter, Lena. I know that’s the kind of thing someone in my position would say, but it’s true. My girl is sleeping safely in her bed just a few miles from here. I’d do anything to protect her. If you look into my eyes, you’ll see that. "), _c('i', [_vm._v("Anything.’")]), _vm._v(" Kate gave her a gentle squeeze. ‘You’ve had to become the mother neither of you had. And that’s not fair. I’m guessing your plan is to go back and rescue her when you can. So, now you have a choice. Go home and let that monster do what he will with you both, always supposing you can escape the clutches of Milos and his traffickers. Or do what I ask, and save not just yourself but Maja too.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kate slid the picture of Lena’s sister closer to her. ‘Take a look at what he did to her last week, then tell me you want me to leave.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lena recoiled, and Kate gripped her wrist. ‘You can do this, Lena.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("‘No … "), _c('i', [_vm._v("no.")]), _vm._v(" I can’t do this. The Russians kill everyone …’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘They won’t need to, if you let your stepfather do it first. We can move your sister beyond his reach. Starting today. The moment you say yes to me, we can start looking for ways of getting her over here, ways of helping her.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kate allowed the silence to lengthen between them. When Lena looked up again, she adopted an expression of regret. ‘If you don’t take this offer, you’ll leave me no choice. You’ll be going back there. To him, to this, and to the mother who did nothing whatsoever to help you. Maja won’t stand a chance.’ She paused. ‘I’ll give you a few minutes to think about it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She stood up, went to the door and left the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rav was leaning against the far side of the glass. ‘Well?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She’ll need a moment or two. But she’s our girl all right.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rav turned and stared at the crumpled figure in the interview room. ‘You can be a ruthless bitch. You know that, don’t you?’")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6605a748","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/prl.vue
// module id = 78
// module chunks = 0